// extracted by mini-css-extract-plugin
export default {"popupWrapper":"JudgesPopup_popupWrapper__w+HLX","parentDiv":"JudgesPopup_parentDiv__Bv65o","contentDiv":"JudgesPopup_contentDiv__g97TZ"};